import { Tabs } from '@mui/material';
import { styled } from '@mui/material/styles';
import Colors from '../../../layout/theme/utils/colors';

const StyledTabs = styled(Tabs)(() => ({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: Colors.navy,
    height: 3,
    '& > span': {
      width: '100%',
      backgroundColor: Colors.white,
    },
  },
}));

export default StyledTabs;
